import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import axios from "axios";
import { Box, Button, Grid, Hidden, useTheme } from "@material-ui/core";
import * as styles from "../styles.scss";

import { tl } from "../../../../../../utils";

import { Popup, SvgIcon } from "../../../../../../components";
import FSStore from "../../../store";
import FSCourseStore from "../../store";
import FSNotifierStore from "../../../../../../components/Notifier/store";
import { IUploadLink } from "../../../types";

let fileUploadCurrentProccessInterval: any;

export const UploadPanel = observer(() => {
  const theme = useTheme();
  const { fsStore, fsCourseStore, fsNotifierStore } = React.useContext<{
    fsStore: FSStore;
    fsCourseStore: FSCourseStore;
    fsNotifierStore: FSNotifierStore;
  }>(MobXProviderContext);

  const [fsLimitDialog, setFsLimitDialog] = React.useState<boolean>(false);
  const [isUploadDialog, setIsUploadDialog] = React.useState<boolean>(false);
  const [uploadError, setUploadError] = React.useState<string>();
  const closeFsLimitDialog = React.useCallback(() => {
    setFsLimitDialog(false);
  }, []);

  let currentFileUploadId = -1;
  const sendUploadAborted = function(e: any) {
    e.preventDefault();
    axios.post(
      `/api/files/uploadaborted`,
      {
        file: currentFileUploadId,
      },
      {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      }
    );
  };

  const onFileuploadSelect = (e: any) => {
    if (!e.target.files) {
      fsStore.switchCheckedFilesWarning(false);
    }
    fsCourseStore.toggleFileUploadInProgress(true);
    fsCourseStore.setFileUploadCurrentProgress(0);
    fsCourseStore.setFileUploadMessage("");
    const files = e.target.files;

    const url = "/panel/files/upload?course_id=" + fsStore.course_id;
    if (files.length) {
      const filesValue = (document as any).querySelector("#filestorage-upload");
      const uploader = [];

      for (let i = 0; i < files.length; i++) {
        const url = "/panel/files/upload?course_id=" + fsStore.course_id;
        const fileData = new FormData();
        fileData.append("course_id", fsStore.course_id.toString());
        if (fsStore.lesson_id) {
          fileData.append("lesson_id", fsStore.lesson_id.toString());
        }
        fileData.append(`files[${i}][name]`, files[i].name);
        fileData.append(`files[${i}][size]`, files[i].size);
        fileData.append(`files[${i}][mimetype]`, files[i].type);
        axios
          .post<Array<IUploadLink>>(url, fileData)
          .then((response) => {
            if (response.data[0].message && response.data[0].message === "SERVICES_DISABLED") {
              window.openServicesDisabledModal(true);
              fsCourseStore.toggleFileUploadInProgress(false);
              filesValue.value = null;
              return;
            }
            const uploadConfig = {
              headers: {
                "Content-type": files[i].type,
              },
              onUploadProgress: (e: any) => {
                const fileUploadCurrentProgressTemp = Math.floor(
                  (e.loaded / e.total) * 100
                );
                fsCourseStore.setFileUploadCurrentProgress(
                  fileUploadCurrentProgressTemp
                );
                if (fsCourseStore.fileUploadCurrentProgress >= 100) {
                  let fileUploadCurrentProccessTemp =
                    fsCourseStore.fileUploadCurrentProccess;
                  fileUploadCurrentProccessInterval = setInterval(() => {
                    fileUploadCurrentProccessTemp++;
                    if (fsCourseStore.fileUploadCurrentProccess >= 100) {
                      fileUploadCurrentProccessTemp = 0;
                    }
                    fsCourseStore.setFileUploadCurrentProccess(
                      fileUploadCurrentProccessTemp
                    );
                  }, 100);
                }
              },
              cancelToken: new axios.CancelToken((c) => {
                fsCourseStore.setCancelToken(c);
              }),
            };
            //@ts-ignore
            const uploadedLink = response.data[0];
            
            if (uploadedLink.result === "error") {
              let reason = uploadedLink.message;
              switch(uploadedLink.message) {
                case 'SERVICES_DISBALED': 
                  reason = "Файл невозможно загрузить т.к. у автора курса закончилось свободное дисковое пространство. Попросите автора расширить место для приема файлов и после этого повторите попытку.";
                  break;
                case 'invalid_file_size_zero':
                  reason = 'Невозможно загрузить пустой файл';
                  break;
              }
              setUploadError(tl(reason));
              fsCourseStore.toggleFileUploadInProgress(false);
            } else {
              currentFileUploadId = uploadedLink.file.id;
              window.addEventListener("beforeunload", sendUploadAborted);

              uploader[i] = axios
                .put(uploadedLink.link, files[i], uploadConfig)
                .then((response) => {
                  window.removeEventListener("beforeunload", sendUploadAborted);
                  axios.post(
                    `/api/files/process`,
                    {
                      file: uploadedLink.file.id,
                    },
                    {
                      headers: {
                        "X-Requested-With": "XMLHttpRequest",
                      },
                    }
                  );
                  clearInterval(fileUploadCurrentProccessInterval);
                  // Файл добавится в урок сразу
                  fsCourseStore.onUpload([uploadedLink.file], true);
                  if (i === files.length - 1) {
                    fsCourseStore.toggleFileUploadInProgress(false);
                    filesValue.value = null;
                  }
                })
                .catch((error) => {
                  window.removeEventListener("beforeunload", sendUploadAborted);
                  axios.post(
                    `/api/files/uploadaborted`,
                    {
                      file: uploadedLink.file.id,
                    },
                    {
                      headers: {
                        "X-Requested-With": "XMLHttpRequest",
                      },
                    }
                  );
                  clearInterval(fileUploadCurrentProccessInterval);
                  if (i === files.length - 1) {
                    fsCourseStore.toggleFileUploadInProgress(false);
                    filesValue.value = null;
                  }
                });
            }
          })
          .catch((error) => {
            fsCourseStore.setFileUploadMessage(
              tl(
                "Произошла ошибка. Попробуйте обновить страницу или выполнить запрос позднее."
              )
            );
            if (i === files.length - 1) {
              fsCourseStore.toggleFileUploadInProgress(false);
              filesValue.value = null;
            }
          });
      }
    }
  };

  React.useEffect(() => {
    const dropZone = document.getElementById("filestorageDrop");
    let curDt: any;

    function showDropZone(evt: any) {
      if (evt.dataTransfer.types) {
        if (evt.dataTransfer.types.includes("Files")) {
          dropZone.style.display = "block";
        }
      }
    }
    function hideDropZone() {
      dropZone.style.display = "none";
    }

    function allowDrag(evt: any) {
      if (true) {
        // Test that the item being dragged is a valid one
        evt.dataTransfer.dropEffect = "copy";
        evt.preventDefault();
        evt.stopPropagation();
      }
    }

    function handleDrop(evt: any) {
      evt.preventDefault();
      evt.stopPropagation();
      var dt = evt.dataTransfer;
      onFileuploadSelect({
        target: dt,
      });
      hideDropZone();
    }

    window.addEventListener("dragenter", showDropZone);
    dropZone.addEventListener("dragenter", allowDrag);
    dropZone.addEventListener("dragover", allowDrag);
    dropZone.addEventListener("dragleave", hideDropZone);
    dropZone.addEventListener("drop", handleDrop);
  }, []);

  return (
    <>
      <Grid item xs={12} sm="auto">
        <Box my={-1}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm="auto">
              <input
                style={{ display: "none" }}
                type="file"
                id="filestorage-upload"
                multiple
                onChange={onFileuploadSelect}
                disabled={
                  fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                }
              />
              <Box id="filestorageDrop" className={styles.dndUpload}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  border={`5px dashed ${theme.palette.primary.light}`}
                  className={styles.dndUploadWrap}
                >
                  {tl("Загрузка файлов в хранилище")}
                </Box>
              </Box>
              {fsCourseStore.filestorageSpaceUsed >=
              fsCourseStore.filestorageSpaceTotal ? (
                <Box display="flex" flexDirection="row" alignItems={'center'} justifyContent={'space-between'} gridGap={8} 
                //@ts-ignore
                style={{textWrap: 'nowrap'}}>
                  <Button
                    variant="contained"
                    fullWidth
                    component="span"
                    disabled={
                      fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                    }
                    onClick={() => {
                      setIsUploadDialog(false);
                      setFsLimitDialog(true);
                    }}
                    startIcon={<SvgIcon type="fs-button-chain" />}
                  >
                    <Hidden only="xs">{tl("Добавить по ссылке")}</Hidden>
                    <Hidden smUp>{tl("По ссылке")}</Hidden>
                  </Button>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={
                      fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                    }
                    onClick={() => {
                      setIsUploadDialog(true);
                      setFsLimitDialog(true);
                    }}
                  >
                    <Hidden only="xs">
                      {fsStore.isWidget
                        ? tl("Загрузить файл")
                        : tl("Загрузить с компьютера")}
                    </Hidden>
                    <Hidden smUp>{tl("Загрузить файл")}</Hidden>
                  </Button>
                </Box>
            
              ) : !fsStore.getCheckedFilesCount ? (
                <Box display="flex" flexDirection="row" alignItems={'center'} justifyContent={'space-between'} gridGap={8} 
                  //@ts-ignore
                  style={{textWrap: 'nowrap'}}>
                  <Button
                    variant="contained"
                    fullWidth
                    component="span"
                    disabled={
                      fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                    }
                    onClick={() => { fsStore.toggleAddVideoLink();
                    }}
                    startIcon={<SvgIcon type="fs-button-chain" />}
                  >
                    <Hidden only="xs">{tl("Добавить по ссылке")}</Hidden>
                    <Hidden smUp>{tl("По ссылке")}</Hidden>
                  </Button>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    component="label"
                    htmlFor="filestorage-upload"
                    disabled={
                      fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                    }
                  >
                    <Hidden only="xs">
                      {fsStore.isWidget
                        ? tl("Загрузить файл")
                        : tl("Загрузить с компьютера")}
                    </Hidden>
                    <Hidden smUp>{tl("Загрузить файл")}</Hidden>
                  </Button>
                </Box>
              ) : (
                <Box display="flex" flexDirection="row" alignItems={'center'} justifyContent={'space-between'} gridGap={8} 
                //@ts-ignore
                style={{textWrap: 'nowrap'}}>
                <Button
                  variant="contained"
                  fullWidth
                  component="span"
                  disabled={
                    fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                  }
                  onClick={() => {
                    fsStore.getCheckedFilesCount
                      ? fsStore.switchCheckedFilesWarning(true, false, true)
                      : fsStore.toggleAddVideoLink();
                  }}
                  startIcon={<SvgIcon type="fs-button-chain" />}
                >
                  <Hidden only="xs">{tl("Добавить по ссылке")}</Hidden>
                  <Hidden smUp>{tl("По ссылке")}</Hidden>
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  disabled={
                    fsCourseStore.isFileUploadInProgress || fsStore.isLoading
                  }
                  onClick={() => {
                    fsStore.switchCheckedFilesWarning(!!fsStore.onAttach, false, false);
                  }}
                >
                  <Hidden only="xs">
                    {fsStore.isWidget
                      ? tl("Загрузить файл")
                      : tl("Загрузить с компьютера")}
                  </Hidden>
                  <Hidden smUp>{tl("Загрузить файл")}</Hidden>
                </Button>
              </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Popup
        header={tl("Внимание!")}
        onClose={() => setUploadError(null)}
        isVisible={!!uploadError}
        bottom={
          <Button variant="contained" onClick={() => setUploadError(null)}>
            {tl("Закрыть")}
          </Button>
        }
      >
        {tl("Ошибка загрузки файла:")} {uploadError}
      </Popup>
      <Popup
        header={"Внимание!"}
        onClose={closeFsLimitDialog}
        bottom={
          <Grid container spacing={2}>
            <Grid item xs={12} sm>
              <Button variant="contained" onClick={closeFsLimitDialog}>
                {tl("Отмена")}
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: "auto" }}
                onClick={() => {
                  !fsStore.getCheckedFilesCount
                    ? closeFsLimitDialog()
                    : fsStore.switchCheckedFilesWarning();

                  if (isUploadDialog) {
                    (document as any)
                      .querySelector("#filestorage-upload")
                      .click();
                  } else {
                    fsStore.getCheckedFilesCount
                      ? fsStore.switchCheckedFilesWarning(true, false, true)
                      : fsStore.toggleAddVideoLink();
                  }
                }}
              >
                {tl("С условиями согласен")}
              </Button>
            </Grid>
          </Grid>
        }
        isVisible={fsLimitDialog}
      >
        {tl(
          "Вы пытаетесь загрузить в хранилище файлов больше, чем выделено на Вашем тарифе. Дополнительное место на хранилище стоит 2 руб. в день за каждый ГБ выше лимита."
        )}
      </Popup>
    </>
  );
});
